import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import ChartStyles from '../../../utils/chart_styles'

// Monthly case-flow chart on the retention management report: cases opened,
// saved, and terminated per month, server-rendered into data values.
export default class extends Controller {
  static targets = ['chart']

  static values = {
    labels: Array,
    opened: Array,
    resolved: Array,
    terminated: Array
  }

  connect() {
    this.chart = new Chart(this.chartTarget, {
      type: 'bar',
      data: {
        labels: this.labelsValue,
        datasets: [
          { label: 'Opened', data: this.openedValue, backgroundColor: ChartStyles.colors.blue },
          { label: 'Saved', data: this.resolvedValue, backgroundColor: ChartStyles.colors.green },
          { label: 'Terminated', data: this.terminatedValue, backgroundColor: ChartStyles.colors.red }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: 'bottom' } },
        scales: {
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
